import winston from 'winston';
import Cookies from 'js-cookie';

const myStageErrorLevels = {
  levels: {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3
  },
  colors: {
    error: 'red',
    warn: 'yellow',
    info: 'green',
    debug: 'blue',
  }
};

const logLevel = Cookies.get('MYSTAGE_DEBUG_LOG_LEVEL') || process.env.VUE_APP_LOG_LEVEL || 'debug';

let winstonLevel = 'debug';
let winstonSilent = false;

if (myStageErrorLevels.levels.hasOwnProperty(logLevel)) {
  winstonLevel = logLevel;
} else if (logLevel === 'none') {
  winstonSilent = true;
}

console.log('Setting log level to ' + logLevel);

const errorObjectToJson = winston.format((info) => {
    if (info.level == 'error') {
        if (info instanceof Error) {
            info.message = info.stack
        }

        if (typeof info.message == 'object') {
            let props = Object.getOwnPropertyNames(info.message);

            // interface instance will result of empty properties
            if (props.length === 0) {
                // get the own properties by getting the prototype first
                props = Object.getOwnPropertyNames(Object.getPrototypeOf(info.message));
            }

            let content = {}
            props.forEach(prop => content[prop] = info.message[prop])
            info.message = JSON.stringify(content)
        }
    }

    return info
});

const winstonLogger = winston.createLogger({
  levels: myStageErrorLevels.levels,
  level: winstonLevel,
  transports: [
    new winston.transports.Console({
      format: winston.format.combine(
        errorObjectToJson(),
        winston.format.colorize(),
        winston.format.simple()
      )
    })
  ],
  silent: winstonSilent
});

export default winstonLogger;
